import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type FilterSectionProps = {
	title: string;
	testIdPrefix: string;
	children: ReactNode;
};

export const FilterSection: FC<FilterSectionProps> = ({
	title,
	testIdPrefix,
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack data-testid={`notification-center-filter-section-${testIdPrefix}`}>
			<Typography
				component="h3"
				sx={{
					fontSize: 11,
					fontWeight: 600,
					color: theme.palette.grey[600],
					textTransform: "uppercase",
					letterSpacing: 0.5,
					px: 1.6,
					pt: 1.2,
					pb: 0.8,
					m: 0,
					backgroundColor: theme.palette.grey[100],
				}}
			>
				{title}
			</Typography>
			<Stack
				role="radiogroup"
				aria-label={title}
				sx={{ backgroundColor: theme.palette.common.white }}
			>
				{children}
			</Stack>
		</Stack>
	);
};
